import { FC, useState } from 'react';
import { Layout } from 'features/Layouts/Layouts';
import {
  useGetBalanceBeneficiarQuery,
  useGetTabPaginationBeneficiarQuery,
} from 'redux/Api/beneficiariesApi/beneficiariesApi';
import { MainTitle } from 'components/MainTitle';
import { BeneficiariesList } from 'components/BeneficiariesList';
import { InputSearch } from 'ui/InputSearch';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import styles from './BeneficiariesContent.module.scss';
import useInfiniteScroll from 'react-infinite-scroll-hook';

const PER_PAGE = 25;

export const BeneficiariesContent: FC = () => {
  const [searchValue, setSearchValue] = useState('');

  const [queryParams, setQueryParams] = useState({
    page: 1,
    per_page: PER_PAGE,
    search: undefined as string | undefined,
  });

  const { data, isLoading, isFetching } = useGetTabPaginationBeneficiarQuery(queryParams);
  const { data: total_balance } = useGetBalanceBeneficiarQuery();

  const customers = data?.data ?? [];
  const isInitialLoading = isLoading && queryParams.page === 1;

  const applySearch = (search?: string) => {
    setQueryParams({
      page: 1,
      per_page: PER_PAGE,
      search: search || undefined,
    });
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      applySearch(searchValue);
    }
  };

  const hasNextPage = data?.meta
    ? data.meta.last_page !== data.meta.current_page
    : false;

  const [intersectionRef] = useInfiniteScroll({
    loading: isLoading || isFetching,
    hasNextPage,
    onLoadMore: () => setQueryParams((prev) => ({ ...prev, page: prev.page + 1 })),
    rootMargin: '0px 0px 800px 0px',
  });

  const balanceData = [
    {
      label: 'Баланс Платформы',
      value: total_balance?.total_balance?.skilla_balance || 0,
    },
    { label: 'Холд Платформы', value: total_balance?.total_balance?.skilla_hold || 0 },
    { label: 'Баланс Банка', value: total_balance?.total_balance?.tochka_balance || 0 },
    { label: 'Холд Банка', value: total_balance?.total_balance?.tochka_hold || 0 },
  ];

  return (
    <Layout>
      <div className={styles.root}>
        <MainTitle title='Заказчики' count={data?.meta?.total} />
        <div className={styles.root_search}>
          <div className={styles.search_input}>
            <InputSearch
              notFocus
              placeholder='Искать'
              value={searchValue}
              onKeyDown={handleKeyDown}
              onSearch={() => applySearch(searchValue)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setSearchValue(e.target.value);

                if (e.target.value === '') {
                  applySearch(undefined);
                }
              }}
            />
          </div>
          <div className={styles.balance_grid}>
            {balanceData.map((item, index) => (
              <div key={index} className={styles.balance_item}>
                <p className={styles.label}>{item.label}</p>
                <p className={styles.value}>{addSpaceNumber(item.value)} ₽</p>
              </div>
            ))}
          </div>
        </div>
        {isInitialLoading ? (
          <LoadingSkeleton />
        ) : (
          <BeneficiariesList data={customers} intersectionRef={intersectionRef} />
        )}
      </div>
    </Layout>
  );
};
